import { useState, useEffect } from "react";
import { Button, useDisclosure } from "@heroui/react";
import { DetalleReclamos } from "../claim";
import { updateData } from "../../services/reclamosService";

export default function ReclamadosToolPanel({ api }) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (!api) return;
        const updateSelection = () => setSelectedRows(api.getSelectedRows());
        api.addEventListener("selectionChanged", updateSelection);
        return () => api.removeEventListener("selectionChanged", updateSelection);
    }, [api]);

    const getSelectedRow = () => selectedRows[0];

    const updateFecha = async (row, nuevaFecha) => {
        const dataToUpdate = {
            id: row.id,
            column: 'expires_at',
            oldValue: row.expires_at,
            newValue: nuevaFecha.toISOString()
        };
        const updatedRow = { ...row, expires_at: nuevaFecha.toISOString() };

        try {
            const res = await updateData(dataToUpdate);
            if (res.status === 200) {
                api.applyTransaction({ update: [updatedRow] });
            } else {
                alert("Error actualizando la fecha");
            }
        } catch (err) {
            alert("Error al conectar al servidor");
        }
    };

    const handleExtension = (dias) => {
        const row = getSelectedRow();
        if (!row) return;
        const nuevaFecha = new Date();
        nuevaFecha.setDate(nuevaFecha.getDate() + dias);
        updateFecha(row, nuevaFecha);
    };

    const handleVencerAhora = () => {
        const row = getSelectedRow();
        if (!row) return;
        const created = new Date(row.created);
        const today = new Date();
        const vencimiento = created < today ? created : today;
        updateFecha(row, vencimiento);
    };

    return (
        <div className="flex flex-col gap-2 p-3">
            <h3 className="font-semibold">Acciones sobre el reclamo</h3>
            <Button size="sm" onPress={() => handleExtension(15)} isDisabled={selectedRows.length === 0}>Extender 15 días</Button>
            <Button size="sm" onPress={() => handleExtension(30)} isDisabled={selectedRows.length === 0}>Extender 30 días</Button>
            <Button size="sm" onPress={() => handleExtension(60)} isDisabled={selectedRows.length === 0}>Extender 60 días</Button>
            <Button size="sm" color="danger" onPress={handleVencerAhora} isDisabled={selectedRows.length === 0}>Marcar como vencido</Button>
            <Button size="sm" color="primary" onPress={onOpen} isDisabled={selectedRows.length === 0}>Ver Detalles</Button>
            <DetalleReclamos isOpen={isOpen} onClose={onClose} selectedRows={selectedRows} />
        </div>
    );
}
